import { defineProductDimensions, mrphPricingVersionDimension, mrphSelectedDimension } from '@orus.eu/dimensions'

import { mrphQuoteV2Dimension } from './mrph-dimensions.ts'
import { mrphProductVersionDimension } from './mrph-product-version-dimension.ts'

export * from './mrph-dimensions.ts'
export * from './mrph-hiscox-activities-vocabulary.ts'
export * from './mrph-subscription-ui.ts'

export const mrphDimensionsModule = defineProductDimensions({
  product: 'mrph',
  family: 'mrp',
  selectionDimension: mrphSelectedDimension,
  productVersionDimension: mrphProductVersionDimension,
  pricingVersionDimension: mrphPricingVersionDimension,
  quoteV2Dimension: mrphQuoteV2Dimension,
})
